export const contactsData = {
    email: "priyankasoniii65@gmail.com",
    phone: "+91-9116473900",
    address: "Zirakpur(Punjab),India",
  
    // sheetAPI: "https://sheetdb.io/api/v1/ukao0wm5smohw",
  };